import { WSPage, WSPageToolbar } from "@wingspanhq/fe-component-library";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import React, { useCallback, useEffect } from "react";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import {
  PATH_EMBEDDED_ONBOARDING,
  PATH_EMBEDDED_ONBOARDING_REQUIREMENT_DETAILS
} from "../../../../Embedded/paths";
import { RequirementDetailsContent } from "../../../../Requirements/components/RequirementsDetails/RequirementDetailsContent";
import { RequirementContextType } from "../../../../Requirements/types";
import { useRequirementsConfig } from "../../../../Requirements/useRequirementsConfig";

type RequirementsDetailsProps = {
  requirement: IRequirementResponse;
};

export const RouteOnboardingRequirementDetailsContent: React.FC<
  RequirementsDetailsProps
> = ({ requirement }) => {
  const history = useHistory();
  const location = useLocation();
  const isEmbedded = !!useRouteMatch(
    PATH_EMBEDDED_ONBOARDING_REQUIREMENT_DETAILS
  );

  const requirementsPath = isEmbedded
    ? `${PATH_EMBEDDED_ONBOARDING}/requirements${location.search}`
    : "/member/onboarding/payee/requirements";

  const goBack = useCallback(() => {
    history.replace(requirementsPath);
  }, [history, requirementsPath]);

  const requirementConfig = useRequirementsConfig({
    requirements: [requirement],
    contextType: RequirementContextType.Payer
  });

  const headerActions =
    requirementConfig.getOnboardingToolbarActions(requirement)?.(goBack) || [];

  const title = requirementConfig.getRequirementName(requirement);

  const handleDocumentKeyUp = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        goBack();
      }
    },
    [goBack]
  );

  useEffect(() => {
    document.addEventListener("keyup", handleDocumentKeyUp);
    return () => {
      document.removeEventListener("keyup", handleDocumentKeyUp);
    };
  }, [handleDocumentKeyUp]);

  return (
    <WSPage>
      <WSPageToolbar title={title} actions={headerActions} />
      <RequirementDetailsContent
        {...requirementConfig}
        key={requirementConfig.dataUpdatedAt}
        contextType={RequirementContextType.Payer}
        requirement={requirement}
        showTitle={false}
      />
    </WSPage>
  );
};
